import React, { useState, useEffect, useCallback } from 'react'
import { Card, ResourceItem, ResourceList, TextStyle, Pagination, TextField, Spinner, Badge } from '@shopify/polaris'
import store from 'store-js'
import { useHistory } from "react-router-dom";
import axios from 'axios'
import { throttle } from 'throttle-debounce';


const Orders = ({ url }) => {

    const history = useHistory()

    const [lastID, setLastID] = useState('')
    const [firstID, setFirstID] = useState('')
    const [page, setPage] = useState(1)
    const [prevPage, setPrevPage] = useState(1)
    const [searchEmail, setSearchEmail] = useState('')
    const [orders, setOrders] = useState([])
    const [loaded, setLoaded] = useState(false)

    // const prevPage = usePrevious(page) || 1;

    useEffect(() => {
        const getOrders = async () => {
            console.log(firstID, lastID)
            const resp = await axios.get(`${url}?page=${page}&prevpage=${prevPage}&firstid=${firstID}&lastid=${lastID}`)
            setOrders(orders => [...resp.data])
            console.log(resp.data[resp.data.length - 1])
            setLoaded(true)
        }
        getOrders()
    }, [url, page, firstID, lastID, prevPage])

    const handlePrevious = useCallback(() => {
        setPrevPage(page)
        setFirstID(firstID => orders.length > 0 && orders[0].cursor)
        setPage(page => (page > 1) ? page-1 : page)
    }, [orders, page])

    const handleNext = useCallback(() => {
        setPrevPage(page)
        setLastID(lastID => orders.length > 0 && orders[orders.length - 1].cursor)
        setPage(page => page+1)
    }, [orders, page])

    const handleSearchChange = useCallback((value) => {
        setSearchEmail(value)
        const getOrders = async () => {
            setLoaded(false)
            var resp = await axios.get(`/orders/search?name=${value}`)
            setOrders(orders => [...resp.data])
            setLoaded(true)
        }
        throttle(500, getOrders)()
    }, [])

    const pagination = orders.length > 0 && (<Pagination
        hasPrevious={prevPage !== page}
        onPrevious={handlePrevious}
        hasNext
        onNext={handleNext}
    />)

    const laoding = !loaded && (
        <Spinner accessibilityLabel="Spinner example" size="large" color="teal" />
    )

    return (
        <>
            <TextField label="Search By Order Name" placeholder="Order number without # e.g. 1002" value={searchEmail} onChange={handleSearchChange} />
            <Card>
                {laoding}
                <ResourceList
                    resourceName={{singular: 'Order', plural: 'Orders'}}
                    items={orders}
                    renderItem={(order) => {
                        const { name, email, legacyResourceId, metafield } = order

                        return (
                        <ResourceItem
                            id={legacyResourceId}
                            onClick={() => {
                                store.set('metafield', metafield)
                                store.set('orderid', legacyResourceId);
                                store.set('ordername', name);
                                store.set('orderemail', email);
                                history.push('/edit')
                            }}
                            accessibilityLabel={`View details for ${name}`}
                        >
                            <h3>
                            <TextStyle variation="strong">{name}</TextStyle>
                            {metafield && (<Badge status="success">Image Added</Badge>)}
                            </h3>
                            <div>{email}</div>
                        </ResourceItem>
                        );
                    }}
                />
            </Card>
            {pagination}
        </>
    )
}

export default Orders